import React, { useState } from "react";
import { DonationModal } from "./DonationModal";

export function DonateButton({
  label = "Donate Now",
  variant = "solid",
  className = "",
  fundraiserId,
  fundraiserTitle = "Fundraiser",
  paymentFor = "TEAM",
  participantId = null,
  participantName = "",
  onClick,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const base =
    "inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all duration-300 cursor-pointer";

  const solid =
    "bg-[#FF6600] text-white hover:bg-[#E65100] shadow-lg hover:shadow-xl transform hover:-translate-y-0.5";

  const outline =
    "border-2 border-[#f89816] text-[#f89816] hover:bg-[#f89816] hover:text-white";

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
      return;
    }
    setIsModalOpen(true);
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        className={`${base} ${variant === "solid" ? solid : outline} ${className}`}
      >
        {label}
      </button>

      <DonationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        fundraiserId={fundraiserId}
        fundraiserTitle={fundraiserTitle}
        paymentFor={paymentFor}
        participantId={participantId}
        participantName={participantName}
      />
    </>
  );
}
